import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
    catchError,
    map,
    concatMap,
    switchMap,
    flatMap,
    tap
} from 'rxjs/operators';
import { PayrollItemService } from '../payroll-item.service';

import * as PayrollItemActions from './payroll-item.actions';
import * as fromShared from '../../../shared';
import { CalcTypeService } from '../../../lookups/calc-type.service';
import { ResponseStatus, DisplayMessageMinimum } from '../../../shared';
import { LoggingService } from '../../../shared/services/logging/logging.service';

@Injectable()
export class PayrollItemEffects {
    getPayrollItems$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(PayrollItemActions.getPayrollItems),
            switchMap(action =>
                this.service.get(action.activeOnly).pipe(
                    flatMap(resp => [
                        new fromShared.Errors.SetErrors(
                            [
                                ...resp
                                    .filter(
                                        r =>
                                            r.Status.StatusCode >=
                                            DisplayMessageMinimum
                                    )
                                    .map(a => a.Status)
                            ].filter(fromShared.Errors.filterErrors)
                        ),
                        PayrollItemActions.loadPayrollItems({
                            payrollItems: resp
                        })
                    ]),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });

    putPayrollItems$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(PayrollItemActions.putPayrollItems),
            tap(action =>
                this.log.verbose({
                    type: 'PayrollItemEffects:putPayrollItems$',
                    action
                })
            ),
            switchMap(a =>
                this.service.put(a.items).pipe(
                    concatMap(resp =>
                        fromShared.Errors.IsSuccessStatus(resp.StatusCode)
                            ? [
                                  PayrollItemActions.upsertPayrollItems({
                                      payrollItems: resp.Items
                                  }),
                                  new fromShared.Errors.RemoveErrors(
                                      resp.Items.filter(
                                          x =>
                                              x.Status.StatusCode ===
                                              ResponseStatus.Success
                                      ).map(x => x.PIListID.toString())
                                  )
                              ]
                            : [
                                  new fromShared.Errors.SetErrors(
                                      fromShared.Errors.MapErrorsToStatus(resp)
                                  ),
                                  PayrollItemActions.upsertPayrollItems({
                                      payrollItems: resp.Items
                                  })
                              ]
                    ),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });

    getLaborTypes$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(PayrollItemActions.getLaborTypes),
            switchMap(() =>
                this.calcTypeService.getCalcType('labor').pipe(
                    map(resp =>
                        PayrollItemActions.loadLaborTypes({ items: resp })
                    ),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });

    constructor(
        private actions$: Actions,
        private service: PayrollItemService,
        private calcTypeService: CalcTypeService,
        private log: LoggingService
    ) {}
}
